// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlpViewButtonGridBase: React.FC<{
    size?: number;
}> = ({ size = 16 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
        <path
            fill="currentColor"
            transform="translate(0 -2.86102e-06)"
            d="M15 5C15 5.5531254 14.553125 6 14 6L2 6C1.4468751 6 1 5.5531254 1 5L1 3C1 2.4468746 1.4468751 2 2 2L14 2C14.553125 2 15 2.4468746 15 3L15 5ZM14 7C15.103125 7 16 6.1031251 16 5L16 3C16 1.8968754 15.103125 1 14 1L2 1C0.8968749 1 0 1.8968754 0 3L0 5C0 6.1031251 0.8968749 7 2 7L14 7ZM16 13L16 11C16 9.8968754 15.103125 9 14 9L2 9C0.8968749 9 0 9.8968754 0 11L0 13C0 14.103125 0.8968749 15 2 15L14 15C15.103125 15 16 14.103125 16 13ZM14 14L2 14C1.4468751 14 1 13.553125 1 13L1 11C1 10.446875 1.4468751 10 2 10L14 10C14.553125 10 15 10.446875 15 11L15 13C15 13.553125 14.553125 14 14 14Z"
        />
    </svg>
);

export default React.memo(PlpViewButtonGridBase);
